import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { splayParams } from "../utils/splay-params";

@Injectable()
export class OnboardingTaskService {
  constructor(private http: HttpClient) {}

  public index(params: any) {
    let projectId: any;

    [params, projectId] = splayParams(params, "projectId");
    const url = `/api/v4/projects/${projectId}/onboarding-tasks`;

    return this.http.get(url, { params });
  }

  public dismissCallout(params: any) {
    let projectId: any;
    let taskId: any;

    [params, projectId, taskId] = splayParams(params, "projectId", "taskId");
    const url = `/api/v4/projects/${projectId}/onboarding-tasks/${taskId}/dismissals`;

    return this.http.post(url, {});
  }
}
